import { render, staticRenderFns } from "./HotContent.vue?vue&type=template&id=b33bbe28&scoped=true"
import script from "./HotContent.vue?vue&type=script&lang=ts"
export * from "./HotContent.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./HotContent.vue?vue&type=style&index=0&id=b33bbe28&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "b33bbe28",
  "5257cd22"
  
)

export default component.exports